{
  "about.blocks": "ma lawa",
  "about.contact": "toki:",
  "about.default_locale": "ante ala",
  "about.disclaimer": "ilo Mastodon la jan ale li lawa e ona li pana e pona tawa ona. kulupu esun Mastodon gGmbH li lawa e nimi ona.",
  "about.domain_blocks.no_reason_available": "mi sona ala e tan",
  "about.domain_blocks.preamble": "ilo Mastodon li ken e ni: sina lukin e toki jan pi ma ilo mute. sina ken toki tawa ona lon kulupu ma. taso, ma ni li ken ala e ni tawa ma ni:",
  "about.domain_blocks.silenced.explanation": "sina lukin ala e toki e jan tan ma ni. taso, sina wile la, sina ken ni.",
  "about.domain_blocks.silenced.title": "ken lukin lili ",
  "about.domain_blocks.suspended.explanation": "sona ale pi ma ni li kama pali ala, li kama esun ala, li kama awen ala la, sina ken ala toki tawa jan pi ma ni.",
  "about.domain_blocks.suspended.title": "weka",
  "about.language_label": "toki",
  "about.not_available": "lon kulupu ni la sina ken alasa ala e sona ni.",
  "about.powered_by": "lipu kulupu pi jan lawa mute tan {mastodon}",
  "about.rules": "lawa kulupu",
  "account.account_note_header": "sona pi sina taso",
  "account.add_or_remove_from_list": "o ante e lipu jan",
  "account.badges.bot": "ilo nanpa li lawa e ni",
  "account.badges.group": "kulupu",
  "account.block": "o len e @{name}",
  "account.block_domain": "o len e ma {domain}",
  "account.block_short": "o len",
  "account.blocked": "jan li len",
  "account.cancel_follow_request": "o kute ala",
  "account.copy": "o pali same e linja pi lipu jan",
  "account.direct": "o mu len e @{name}",
  "account.disable_notifications": "@{name} li toki la o mu ala e mi",
  "account.edit_profile": "o ante e lipu mi",
  "account.edit_profile_short": "o ante",
  "account.enable_notifications": "@{name} li toki la o mu e mi",
  "account.endorse": "lipu jan la o suli e ni",
  "account.familiar_followers_many": "{name1} en {name2} en {othersCount, plural, other {jan ante #}} li kute e jan ni",
  "account.familiar_followers_one": "{name1} li kute e jan ni",
  "account.familiar_followers_two": "{name1} en {name2} li kute e jan ni",
  "account.featured": "suli",
  "account.featured.accounts": "lipu jan",
  "account.follow": "o kute",
  "account.follow_back": "jan ni li kute e sina. o kute",
  "account.follow_back_short": "o kute",
  "account.follow_request": "o wile kute",
  "account.follow_request_cancel": "o wile ala kute",
  "account.follow_request_cancel_short": "o wile ala kute",
  "account.followers": "jan kute",
  "account.followers.empty": "jan ala li kute e jan ni",
  "account.followers_counter": "{count, plural, other {jan {counter} li kute e ona}}",
  "account.followers_you_know_counter": "jan {counter} pi kute sama",
  "account.following": "sina kute e jan ni",
  "account.following_counter": "{count, plural, other {ona li kute e jan {counter}}}",
  "account.follows.empty": "jan ni li kute ala e jan",
  "account.follows_you": "ona li kute e sina",
  "account.go_to_profile": "o tawa lipu jan",
  "account.hide_reblogs": "o lukin ala e pana toki tan @{name}",
  "account.in_memoriam": "jan ni li moli. pona o tawa ona.",
  "account.joined_short": "ona li kama lon tenpo",
  "account.languages": "sina wile lukin e sitelen pi toki seme",
  "account.link_verified_on": "{date} la mi sona e ni: jan seme li jo e lipu ni",
  "account.locked_info": "sina wile kute e jan ni la ona o toki e ken",
  "account.media": "sitelen",
  "account.mention": "o mu e @{name}",
  "account.moved_to": "jan ni la lipu sin li ni:",
  "account.mute": "o len e @{name}",
  "account.mute_notifications_short": "o kute ala e mu tan jan ni",
  "account.mute_short": "o kute ala",
  "account.muted": "sina kute ala e jan ni",
  "account.mutual": "ona li kute e sina. sina kute e ona.",
  "account.no_bio": "lipu li weka.",
  "account.open_original_page": "o open e lipu open",
  "account.posts": "toki suli",
  "account.remove_from_followers": "sijelo kute la o weka e sijelo \"{name}\".",
  "account.report": "@{name} la o toki e jaki tawa lawa",
  "account.requested_follow": "{name} li wile kute e sina",
  "account.share": "o pana e lipu tan @{name}",
  "account.show_reblogs": "o lukin e pana toki tan @{name}",
  "account.statuses_counter": "{count, plural, other {toki {counter}}}",
  "account.unblock": "o len ala e {name}",
  "account.unblock_domain": "o len ala e ma {domain}",
  "account.unblock_domain_short": "o len ala",
  "account.unblock_short": "o len ala",
  "account.unendorse": "lipu jan la o suli ala e ni",
  "account.unfollow": "o kute ala",
  "account.unmute": "o len ala e @{name}",
  "account.unmute_notifications_short": "o kute e mu",
  "account.unmute_short": "o len ala",
  "account_note.placeholder": "o luka e ni la sona pi sina taso",
  "admin.dashboard.daily_retention": "nanpa pi awen jan lon tenpo suno",
  "admin.dashboard.monthly_retention": "nanpa pi awen jan lon tenpo mun",
  "admin.dashboard.retention.average": "sama",
  "admin.dashboard.retention.cohort": "kama sijelo la tenpo mun",
  "admin.dashboard.retention.cohort_size": "jan sin",
  "admin.impact_report.instance_accounts": "ni li pakala li weka e lipu jan ni",
  "admin.impact_report.instance_followers": "jan pi ma mi li weka tan jan kute ni",
  "admin.impact_report.instance_follows": "ma ante li weka tan jan kute ni",
  "admin.impact_report.title": "sona pi pakala kulupu",
  "alert.rate_limited.message": "tenpo {retry_time, time, medium} la o pali awen",
  "alert.rate_limited.title": "ilo ni li lili e ken sina",
  "alert.unexpected.message": "pakala li lon",
  "alert.unexpected.title": "pakala a!",
  "alt_text_badge.title": "toki pi sona lukin",
  "alt_text_modal.add_alt_text": "o pana e toki pi sona lukin",
  "alt_text_modal.add_text_from_image": "o pana e nimi tan sitelen ni",
  "alt_text_modal.cancel": "o weka",
  "alt_text_modal.change_thumbnail": "o ante e sitelen lili",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "jan li ken ala kute la o pana e toki pi sona kalama…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "jan li ken ala lukin la o pana e toki pi sona lukin…",
  "alt_text_modal.done": "o pana",
  "announcement.announcement": "toki suli",
  "annual_report.summary.most_used_app.most_used_app": "ilo pi kepeken suli",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "kulupu toki pi kepeken suli",
  "annual_report.summary.new_posts.new_posts": "toki suli sin",
  "annual_report.summary.percentile.text": "<topLabel>ni la sina nanpa sewi</topLabel><percentage></percentage><bottomLabel>pi jan ale lon {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "sona ni li len tawa ale.",
  "attachments_list.unprocessed": "(nasin open)",
  "audio.hide": "o len e kalama",
  "block_modal.remote_users_caveat": "mi pana e wile sina tawa ma {domain}. taso ma li ken kepeken nasin ante la pakala li ken. jan li awen ken lukin e toki kepeken sijelo ala.",
  "block_modal.show_less": "o lili e toki",
  "block_modal.show_more": "o suli e toki",
  "block_modal.they_will_know": "ona li ken sona e ni: sina len e ona.",
  "block_modal.title": "o len ala len e jan?",
  "boost_modal.combo": "sina ken luka e nena {combo} tawa ni: sina wile ala luka e nena lon tenpo kama",
  "boost_modal.reblog": "o pana ala pana sin e toki?",
  "boost_modal.undo_reblog": "o weka ala weka e pana toki?",
  "bundle_column_error.copy_stacktrace": "o jo e sona pakala lon ilo sina",
  "bundle_column_error.error.body": "ilo li ken ala pana e lipu ni. ni li ken tan pakala ilo.",
  "bundle_column_error.error.title": "pakala a!",
  "bundle_column_error.network.body": "mi lukin pana e lipu la, pakala li lon. ken la, pakala li tan ilo nanpa sina. ken la, pakala li tan ilo nanpa suli pi ma kulupu ni.",
  "bundle_column_error.network.title": "pakala la ilo sina li toki ala tawa ilo ante",
  "bundle_column_error.retry": "o alasa sin",
  "bundle_column_error.return": "o tawa open",
  "bundle_column_error.routing.body": "ilo li sona ala e lipu wile. sina pana ala pana e nasin pona tawa lipu?",
  "bundle_column_error.routing.title": "pakala #404",
  "bundle_modal_error.close": "o pini",
  "bundle_modal_error.message": "ilo li wile kama e ijo ni, taso pakala li lon.",
  "bundle_modal_error.retry": "o alasa sin",
  "carousel.current": "<sr>lipu</sr> {current, number} / {max, number}",
  "carousel.slide": "lipu {current, number} lon {max, number}",
  "closed_registrations.other_server_instructions": "kulupu Mastodon la lawa mute li lon. sina ken pali e sijelo lon ma ante la sina awen ken lukin e ijo pi ma ni.",
  "closed_registrations_modal.description": "tenpo ni la, sina ken ala pali e jan lon ma {domain}. taso sina wile kepeken ilo Mastodon la, sina ken pali e jan lon ma ante lon ala ma {domain}.",
  "closed_registrations_modal.find_another_server": "o alasa e ma ante",
  "closed_registrations_modal.preamble": "ilo Mastodon li lon ilo wan ala. sina kepeken ma ante la sina ken lukin li ken kute e jan pi ma ni. sina wile la, sina ken pali e ma sin!",
  "closed_registrations_modal.title": "sina kama lon kulupu Mastodon",
  "column.about": "sona",
  "column.blocks": "jan len",
  "column.bookmarks": "awen toki",
  "column.community": "linja tenpo pi ma ni",
  "column.create_list": "o pali e kulupu",
  "column.direct": "mu len",
  "column.directory": "o lukin e jan",
  "column.domain_blocks": "ma len",
  "column.edit_list": "o ante e kulupu",
  "column.favourites": "ijo pona",
  "column.firehose": "toki pi tenpo ni",
  "column.firehose_local": "ma ni la toki pi tenpo ni",
  "column.firehose_singular": "toki pi tenpo ni",
  "column.follow_requests": "wile kute",
  "column.home": "lipu open",
  "column.list_members": "o ante e kulupu jan",
  "column.lists": "kulupu lipu",
  "column.mutes": "jan len",
  "column.notifications": "mu pi sona sin",
  "column.pins": "toki sewi",
  "column.public": "toki pi ma poka ale",
  "column_back_button.label": "o weka",
  "column_header.hide_settings": "o len e nasin lawa",
  "column_header.moveLeft_settings": "poki toki ni o tawa ni ←",
  "column_header.moveRight_settings": "poki toki ni o tawa ni →",
  "column_header.pin": "o sewi",
  "column_header.show_settings": "o lukin e nasin lawa",
  "column_header.unpin": "o sewi ala",
  "column_search.cancel": "o ala",
  "community.column_settings.local_only": "toki tan ni taso",
  "community.column_settings.media_only": "sitelen taso",
  "community.column_settings.remote_only": "toki tan ante taso",
  "compose.error.blank_post": "toki li wile.",
  "compose.language.change": "o ante e nasin toki",
  "compose.language.search": "o alasa e nasin toki...",
  "compose.published.body": "mi pana e toki.",
  "compose.published.open": "o lukin",
  "compose.saved.body": "mi awen e toki sina.",
  "compose_form.direct_message_warning_learn_more": "o sona",
  "compose_form.encryption_warning": "ilo Mastodon la toki li len ala. o pana ala e sona suli pi ken pakala.",
  "compose_form.lock_disclaimer": "lipu sina li {locked} ala. jan ale li ken kama kute e sina li ken lukin e toki sama ni.",
  "compose_form.lock_disclaimer.lock": "pini",
  "compose_form.placeholder": "sina wile toki e seme?",
  "compose_form.poll.duration": "tenpo pana",
  "compose_form.poll.multiple": "mute pana",
  "compose_form.poll.option_placeholder": "ken nanpa {number}",
  "compose_form.poll.single": "ken pi wan taso",
  "compose_form.poll.switch_to_multiple": "o ante e nasin pana. pana mute o ken",
  "compose_form.poll.switch_to_single": "o ante e nasin pana. pana wan taso o lon",
  "compose_form.poll.type": "nasin",
  "compose_form.publish": "o toki",
  "compose_form.reply": "o toki lon ijo ni",
  "compose_form.save_changes": "o sin",
  "compose_form.spoiler.marked": "o weka e toki pi ijo ike ken",
  "compose_form.spoiler.unmarked": "o pali e toki pi ijo ike ken",
  "compose_form.spoiler_placeholder": "toki pi ijo ike ken (sina ken ala e ni)",
  "confirmation_modal.cancel": "ala",
  "confirmations.block.confirm": "o len",
  "confirmations.delete.confirm": "o weka",
  "confirmations.delete.message": "sina wile ala wile weka e toki ni?",
  "confirmations.delete.title": "o weka ala weka e toki?",
  "confirmations.delete_list.confirm": "o weka",
  "confirmations.delete_list.message": "sina wile ala wile weka e lipu ni?",
  "confirmations.delete_list.title": "o weka ala weka e kulupu lipu?",
  "confirmations.discard_draft.confirm": "o weka e toki ni",
  "confirmations.discard_draft.edit.cancel": "o awen o ante",
  "confirmations.discard_draft.edit.message": "sina awen e ni la ona li weka e ante sina pi tenpo ni lon toki ni.",
  "confirmations.discard_draft.edit.title": "sina wile ala wile weka e ante toki?",
  "confirmations.discard_draft.post.cancel": "awen la o sitelen",
  "confirmations.discard_draft.post.message": "sina awen e ni la ona li weka e toki ni.",
  "confirmations.discard_draft.post.title": "sina wile ala wile weka e toki ni?",
  "confirmations.discard_edit_media.confirm": "o weka",
  "confirmations.discard_edit_media.message": "toki sitelen anu lukin lili sitelen la ante pi awen ala li lon. sina wile weka e ante ni?",
  "confirmations.follow_to_list.confirm": "o kute, o pana tawa lipu jan",
  "confirmations.follow_to_list.message": "sina wile pana e {name} tawa lipu jan la o kama kute e ona.",
  "confirmations.follow_to_list.title": "sina wile ala wile kute?",
  "confirmations.logout.confirm": "o weka",
  "confirmations.logout.message": "sina wile ala wile weka",
  "confirmations.logout.title": "o weka ala weka?",
  "confirmations.missing_alt_text.confirm": "o pana e toki pi sona lukin",
  "confirmations.missing_alt_text.message": "toki ni la sitelen li lon. taso toki pi sona lukin li lon ala. toki pi sona lukin li pona tan ni: jan ale li ken sona e toki.",
  "confirmations.missing_alt_text.secondary": "o pana a",
  "confirmations.missing_alt_text.title": "o pana ala pana e toki pi sona lukin?",
  "confirmations.mute.confirm": "o len",
  "confirmations.private_quote_notify.confirm": "o pana e toki ni tawa ale",
  "confirmations.private_quote_notify.do_not_show_again": "o toki ala e toki ni",
  "confirmations.quiet_post_quote_info.dismiss": "o toki ala e ni tawa mi",
  "confirmations.quiet_post_quote_info.got_it": "sona",
  "confirmations.redraft.confirm": "o weka o pali sin e toki",
  "confirmations.redraft.message": "pali sin e toki ni la sina wile ala wile weka e ona? sina ni la suli pi toki ni en wawa pi toki ni li weka. kin la toki lon toki ni li jo e mama ala.",
  "confirmations.redraft.title": "ni li weka li pali sin e toki ni.",
  "confirmations.remove_from_followers.confirm": "o kama kute ala e jan",
  "confirmations.remove_from_followers.message": "{name} li kama kute ala e sina. sina wile ala wile e ni?",
  "confirmations.remove_from_followers.title": "o kama ala kama kute ala e jan?",
  "confirmations.revoke_quote.confirm": "o weka e toki tan lipu Mastodon",
  "confirmations.revoke_quote.title": "sina wile weka ala weka e toki?",
  "confirmations.unblock.confirm": "o len ala",
  "confirmations.unblock.title": "o len ala e {name}?",
  "confirmations.unfollow.confirm": "o kute ala",
  "confirmations.unfollow.title": "o kute ala e {name}?",
  "content_warning.hide": "o len",
  "content_warning.show": "o lukin a",
  "content_warning.show_more": "o lukin",
  "conversation.delete": "o weka e toki ni",
  "conversation.mark_as_read": "ni o sin ala",
  "conversation.open": "o lukin e toki",
  "conversation.with": "lon {names}",
  "copy_icon_button.copied": "sina jo e toki",
  "copypaste.copied": "sina jo e toki",
  "copypaste.copy_to_clipboard": "o jo e toki",
  "directory.federated": "tan lipu ante sona",
  "directory.local": "tan ma {domain} taso",
  "directory.new_arrivals": "jan pi kama sin",
  "directory.recently_active": "jan lon tenpo poka",
  "disabled_account_banner.account_settings": "wile pi lipu jan",
  "disabled_account_banner.text": "sina ken ala lon sijelo {disabledAccount}.",
  "dismissable_banner.community_timeline": "ni li toki suli pi len ala lon ma {domain} tan tenpo poka.",
  "dismissable_banner.dismiss": "o weka",
  "dismissable_banner.public_timeline": "toki ni li sin. jan li pali e toki ni la jan ante mute pi ma {domain} li kute e jan ni.",
  "domain_block_modal.block": "o len e ma",
  "domain_block_modal.block_account_instead": "o len e @{name} a",
  "domain_block_modal.they_can_interact_with_old_posts": "jan pi ma ni li ken ijo e toki sina.",
  "domain_block_modal.they_cant_follow": "jan pi ma ni li ken ala kute e sina.",
  "domain_block_modal.they_wont_know": "ona li sona ala e ni: sina len e ona.",
  "domain_block_modal.title": "sina wile ala wile len e ma?",
  "domain_block_modal.you_will_lose_num_followers": "{followersCount, plural, other {jan {followersCountDisplay}}} li kute e sina la, ona kama kute ala e sina. sina kute e {followingCount, plural,other {jan {followingCountDisplay}}} la, sina kama kute ala e ona.",
  "domain_block_modal.you_will_lose_relationships": "jan li lon kulupu ni la ona kute e sina la, ona li kama kute ala e sina. jan li lon kulupu ni la sina kute e ona la, sina kama kute ala e ona.",
  "domain_block_modal.you_wont_see_posts": "sina ken ala lukin e toki tan jan pi ma ni",
  "domain_pill.activitypub_lets_connect": "ilo ni la sina ken toki tawa jan ante. ni li lon ma Mastodon taso ala li lon ma mute a.",
  "domain_pill.activitypub_like_language": "ilo Mastodon li toki kepeken nasin ActivityPub tawa kulupu ilo ante.",
  "domain_pill.server": "ma",
  "domain_pill.their_handle": "nimi pi ona taso li ni:",
  "domain_pill.their_server": "ni li ma ona lon ilo. toki ale ona li lon ma ni.",
  "domain_pill.their_username": "ni li nimi ona lon ma ni. jan mute li lon ma ante la, nimi ona li ken sama.",
  "domain_pill.username": "nimi jan",
  "domain_pill.whats_in_a_handle": "seme li lon nimi?",
  "domain_pill.who_they_are": "nimi ilo la sona jan en sona ma li lon. ni la sina ken toki tawa jan ni lon <button>kulupu ma ale</button>.",
  "domain_pill.your_handle": "nimi sina:",
  "domain_pill.your_server": "ni li ma sina lon ilo. toki ale sina li lon ma ni. ma li ike tawa sina la, sina ken tawa ma ante. ni la jan kute sina li tawa sama.",
  "domain_pill.your_username": "ni li nimi sina. ma sina la, sina taso li jo e ona. jan mute li lon ma ante la, ona li ken jo e nimi sama.",
  "dropdown.empty": "o wile e ijo wan",
  "embed.instructions": "o pana e toki ni la, toki li lon lipu ante. ",
  "embed.preview": "ni li jo e sitelen ni:",
  "emoji_button.activity": "musi",
  "emoji_button.clear": "o weka",
  "emoji_button.custom": "pali sin",
  "emoji_button.flags": "len ma",
  "emoji_button.food": "moku",
  "emoji_button.label": "o pana e sitelen pilin",
  "emoji_button.nature": "soweli en kasi",
  "emoji_button.not_found": "sitelen pilin ala li lon",
  "emoji_button.objects": "ijo",
  "emoji_button.people": "jan",
  "emoji_button.recent": "kepeken suli",
  "emoji_button.search": "o alasa...",
  "emoji_button.search_results": "ijo pi alasa ni",
  "emoji_button.symbols": "sitelen",
  "emoji_button.travel": "ma en tawa",
  "empty_column.account_hides_collections": "jan ni li wile len e sona ni",
  "empty_column.account_suspended": "lipu ni li weka",
  "empty_column.account_timeline": "toki ala li lon!",
  "empty_column.account_unavailable": "ken ala lukin e lipu jan",
  "empty_column.blocks": "sina len ala e jan.",
  "empty_column.direct": "jan ala li toki len e sina. jan li toki len e sina la sina ken lukin e ni lon ni.",
  "empty_column.domain_blocks": "sina len ala e ma.",
  "empty_column.explore_statuses": "tenpo ni la ala li namako. o lukin sin a lon tenpo ante!",
  "empty_column.favourited_statuses": "sina suli ala e toki. sina suli e toki la sina ken lukin e toki ni lon ni.",
  "empty_column.favourites": "jan ala li suli e toki ni. jan li suli e toki ni la sina ken lukin e ona lon ni.",
  "empty_column.follow_requests": "jan ala li toki pi wile kute tawa sina. jan li toki pi wile kute tawa sina la sina ken lukin e toki ni lon ni.",
  "empty_column.followed_tags": "sina kute ala e kulupu lipu. sina kute la toki li kama lon ni.",
  "empty_column.hashtag": "toki ala li lon kulupu ni.",
  "empty_column.home": "ala a li lon lipu open sina! sina wile lon e ijo lon ni la o kute e jan pi toki suli.",
  "empty_column.list": "ala li lon kulupu lipu ni. jan pi kulupu lipu ni li toki sin la toki ni li lon ni.",
  "empty_column.mutes": "jan ala li len tawa sina.",
  "error.unexpected_crash.explanation": "ilo li ken ala pana e lipu ni. ni li ken tan pakala mi tan pakala pi ilo sina.",
  "errors.unexpected_crash.copy_stacktrace": "o jo e sona pakala lon poki awen",
  "errors.unexpected_crash.report_issue": "o toki e pakala tawa lawa",
  "explore.suggested_follows": "jan",
  "explore.trending_links": "sin",
  "explore.trending_statuses": "toki",
  "explore.trending_tags": "kulupu pi lipu suli",
  "featured_carousel.current": "<sr>toki</sr>{current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {toki sewi}}",
  "featured_carousel.slide": "toki {current, number} lon {max, number}",
  "filter_modal.added.review_and_configure_title": "o alasa e lawa",
  "filter_modal.added.settings_link": "lipu lawa",
  "filter_modal.select_filter.expired": "tenpo pini",
  "filter_modal.select_filter.search": "o alasa anu pali",
  "filter_warning.matches_filter": "alasa \"<span>{title}</span>\" la ni li lon",
  "filtered_notifications_banner.pending_requests": "ni li tan {count, plural, =0 {jan sina ala} other {jan sina #}}",
  "firehose.all": "ale",
  "firehose.local": "kulupu ni",
  "firehose.remote": "kulupu ante",
  "follow_request.authorize": "o ken",
  "follow_request.reject": "o weka kute",
  "follow_suggestions.dismiss": "mi wile lukin sin ala e ni",
  "follow_suggestions.friends_of_friends_longer": "ni li suli tawa kulupu jan ni: sina kute e ona",
  "follow_suggestions.hints.friends_of_friends": "jan kute sina li lukin mute e toki pi jan ni.",
  "follow_suggestions.hints.most_followed": "jan mute lon ma {domain} li kute e jan ni.",
  "follow_suggestions.hints.most_interactions": "tenpo poka la jan mute pi ma {domain} li lukin mute e toki pi jan ni.",
  "follow_suggestions.hints.similar_to_recently_followed": "sina kute e jan lon tenpo poka la jan ni li sama ona.",
  "follow_suggestions.view_all": "o lukin e ale",
  "follow_suggestions.who_to_follow": "sina o kute e ni",
  "footer.about": "sona",
  "footer.directory": "lipu jan",
  "footer.get_app": "o jo e ilo",
  "footer.privacy_policy": "lawa len",
  "footer.source_code": "o lukin e toki ilo",
  "footer.status": "lon",
  "footer.terms_of_service": "lipu lawa",
  "generic.saved": "mi awen e ni",
  "getting_started.heading": "mi open",
  "hashtag.admin_moderation": "o lawa e kulupu #{name}",
  "hashtag.browse": "o lukin e kulupu toki #{hashtag}",
  "hashtag.browse_from_account": "o lukin e kulupu toki #{hashtag} tan @{name}",
  "hashtag.column_header.tag_mode.all": "en {additional}",
  "hashtag.column_header.tag_mode.any": "anu {additional}",
  "hashtag.column_header.tag_mode.none": "en {additional} ala",
  "hashtag.column_settings.select.placeholder": "o alasa e kulupu…",
  "hashtag.column_settings.tag_mode.all": "ale ni",
  "hashtag.column_settings.tag_mode.any": "wan ni",
  "hashtag.column_settings.tag_mode.none": "ala ni",
  "hashtag.counter_by_accounts": "{count, plural, other {jan {counter}}}",
  "hashtag.counter_by_uses": "{count, plural, other {toki {counter}}}",
  "hashtag.counter_by_uses_today": "{count, plural, other {toki poka {counter}}}",
  "hashtag.feature": "lipu jan la o suli e ni",
  "hashtag.follow": "o kute e kulupu lipu",
  "hashtag.mute": "o kute ala e kulupu #{hashtag}",
  "hashtag.unfeature": "lipu jan la o suli ala e ni",
  "hashtag.unfollow": "o kute ala e kulupu lipu",
  "hints.profiles.followers_may_be_missing": "jan kute li ken weka.",
  "hints.profiles.see_more_followers": "o lukin e jan ni lon ma {domain}: ona li kute e jan ni.",
  "hints.profiles.see_more_follows": "o lukin e jan ni lon ma {domain}: jan ni li kute e ona.",
  "hints.profiles.see_more_posts": "o lukin e toki ante lon ma {domain}",
  "home.column_settings.show_reblogs": "o lukin e pana toki",
  "home.hide_announcements": "o lukin ala e toki lawa suli",
  "home.pending_critical_update.body": "o sin e ilo Mastodon lon tenpo lili a!",
  "home.pending_critical_update.link": "o lukin e ijo ilo sin",
  "home.pending_critical_update.title": "pakala suli li lon ilo sina a!",
  "home.show_announcements": "o lukin e toki lawa suli",
  "ignore_notifications_modal.ignore": " o kute ala e mu",
  "info_button.label": "sona",
  "info_button.what_is_alt_text": "<h1>toki pi sona lukin li seme?</h1> <p>toki ni li pana e sona tan sitelen lukin tawa jan mute ni: ona li ken ala lukin. ona li wile e sona namako.</p>  <p>sina ken pana e sona pona kepeken nasin ni:</p> <ul> <li>o toki pona.</li> <li>o toki e ijo suli lon sitelen.</li> <li>o toki lili e nimi lon sitelen.</li> <li>o toki suli ala e ijo lili.</li> </ul>",
  "interaction_modal.go": "o tawa",
  "interaction_modal.no_account_yet": "sina jo ala e sijelo anu seme?",
  "interaction_modal.on_another_server": "lon ma ante",
  "interaction_modal.on_this_server": "lon ma ni",
  "interaction_modal.username_prompt": "ni li sama ni: {example}",
  "intervals.full.days": "ni li pini lon {number, plural, other {tenpo suno #}}",
  "intervals.full.hours": "ni li pini lon {number, plural, other {tenpo ilo #}}",
  "intervals.full.minutes": "ni li pini lon {number, plural, other {tenpo ilo lili #}}",
  "keyboard_shortcuts.back": "o tawa pini",
  "keyboard_shortcuts.blocked": "o lukin e lipu pi len sina",
  "keyboard_shortcuts.boost": "o pana sin e toki",
  "keyboard_shortcuts.down": "o tawa anpa lon lipu",
  "keyboard_shortcuts.enter": "o lukin e toki",
  "keyboard_shortcuts.favourite": "o sitelen pona e toki",
  "keyboard_shortcuts.favourites": "o lukin e lipu sina pi toki suli",
  "keyboard_shortcuts.federated": "o lukin e linja toki pi ma ale",
  "keyboard_shortcuts.muted": "o lukin e lipu sina pi jan len",
  "keyboard_shortcuts.my_profile": "o lukin e lipu sina",
  "keyboard_shortcuts.open_media": "o lukin e sitelen",
  "keyboard_shortcuts.pinned": "o lukin pi toki sina sewi",
  "keyboard_shortcuts.reply": "o toki lon ijo ni",
  "keyboard_shortcuts.toggle_hidden": "o lukin ala lukin e toki len",
  "keyboard_shortcuts.toggle_sensitivity": "o lukin ala lukin e sitelen",
  "keyboard_shortcuts.toot": "o toki sin",
  "keyboard_shortcuts.translate": "o ante e toki lipu",
  "keyboard_shortcuts.up": "o tawa sewi lon lipu",
  "learn_more_link.got_it": "sona",
  "lightbox.close": "o pini",
  "lightbox.next": "sinpin",
  "lightbox.previous": "monsi",
  "link_preview.author": "tan {name}",
  "link_preview.shares": "{count, plural, other {toki {counter}}}",
  "lists.add_member": "o pana",
  "lists.add_to_list": "o pana tawa kulupu jan",
  "lists.add_to_lists": "o pana e {name} tawa kulupu jan",
  "lists.create": "o lipu e kulupu jan",
  "lists.create_a_list_to_organize": "o lipu e kulupu tawa nasin pi ilo sina",
  "lists.create_list": "o lipu e kulupu jan",
  "lists.delete": "o weka e kulupu lipu",
  "lists.done": "ale li pini",
  "lists.edit": "o ante e kulupu lipu",
  "lists.find_users_to_add": "o alasa e jan",
  "lists.list_members_count": "{count, plural, other {jan #}}",
  "lists.list_name": "nimi kulupu",
  "lists.new_list_name": "nimi pi kulupu sin",
  "lists.no_lists_yet": "kulupu li lon ala.",
  "lists.no_members_yet": "jan ala li lon.",
  "lists.no_results_found": "jan ala li lon.",
  "lists.remove_member": "o weka",
  "lists.replies_policy.followed": "jan kute ale",
  "lists.replies_policy.list": "jan pi kulupu ni taso",
  "lists.replies_policy.none": "jan ala",
  "lists.save": "o awen",
  "lists.search": "o alasa",
  "load_pending": "{count, plural, other {ijo sin #}}",
  "loading_indicator.label": "ni li kama…",
  "media_gallery.hide": "o len",
  "moved_to_account_banner.text": "sina ante e sijelo tawa sijelo {movedToAccount}. ni la sijelo {disabledAccount} li pini.",
  "mute_modal.hide_from_notifications": "o len tan mu",
  "mute_modal.indefinite": "ni li pini ala",
  "mute_modal.title": "sina wile ala wile kute e jan ni?",
  "navigation_bar.about": "sona",
  "navigation_bar.blocks": "jan len",
  "navigation_bar.domain_blocks": "ma len",
  "navigation_bar.favourites": "ijo pona",
  "navigation_bar.filters": "nimi len",
  "navigation_bar.lists": "kulupu lipu",
  "navigation_bar.logout": "o weka tan sijelo",
  "navigation_bar.moderation": "nasin lawa",
  "navigation_bar.mutes": "sina wile ala kute e jan ni",
  "navigation_bar.preferences": "wile sina",
  "navigation_bar.search": "o alasa",
  "notification.admin.report": "jan {name} li toki e jan {target} tawa lawa",
  "notification.admin.sign_up": "{name} li kama",
  "notification.favourite": "toki sina li pona tawa {name}",
  "notification.follow": " {name} li kute e sina",
  "notification.follow_request": "{name} li wile kute e sina",
  "notification.label.mention": "jan li toki e sina",
  "notification.label.private_mention": "jan li toki e sina lon len",
  "notification.label.private_reply": "toki len",
  "notification.label.reply": "jan li toki tawa toki sina",
  "notification.mentioned_you": "jan {name} li toki e sina",
  "notification.moderation-warning.learn_more": "o sona",
  "notification.reblog": "{name} li wawa e toki sina",
  "notification.relationships_severance_event.domain_block": "ma {from} la jan lawa li len e ma {target}. ma ni la jan {followersCount} li kute e sina. sina kute e {followingCount, plural, other {jan #}} tan ma ni. kama la ona ale li len tawa sina.",
  "notification.relationships_severance_event.learn_more": "o sona",
  "notification.relationships_severance_event.user_domain_block": "sina len e ma {target}. ma ni la jan {followersCount} li kute e sina. sina kute e {followingCount, plural, other {jan #}} tan ma ni. kama la ona ale li len tawa sina.",
  "notification.status": "{name} li toki",
  "notification.update": "{name} li ante e toki",
  "notification_requests.dismiss": "o weka",
  "notifications.column_settings.favourite": "ijo pona:",
  "notifications.column_settings.follow": "jan kute sin",
  "notifications.column_settings.poll": "pana lon pana ni:",
  "notifications.column_settings.reblog": "pana sin:",
  "notifications.column_settings.status": "toki sin:",
  "notifications.column_settings.update": "ante toki:",
  "notifications.filter.all": "ale",
  "notifications.filter.boosts": "pana sin",
  "notifications.filter.favourites": "ijo pona",
  "notifications.filter.mentions": "toki pi toki sina",
  "notifications.filter.polls": "pana lon pana ni",
  "onboarding.follows.search": "o alasa",
  "onboarding.profile.display_name": "nimi tawa jan ante",
  "onboarding.profile.note": "sona sina",
  "poll.closed": "ona li pini",
  "poll.total_people": "{count, plural, other {jan #}}",
  "poll.total_votes": "{count, plural, other {pana #}}",
  "poll.vote": "o pana",
  "poll.voted": "sina pana e ni",
  "poll.votes": "{votes, plural, other {pana #}}",
  "privacy.direct.long": "jan ale lon toki",
  "privacy.public.short": "tawa ale",
  "relative_time.days": "{number}d",
  "relative_time.full.just_now": "tenpo ni",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "tenpo ni",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "tenpo suno ni",
  "remove_quote_hint.button_label": "sona",
  "reply_indicator.attachments": "{count, plural, other {sitelen #}}",
  "reply_indicator.cancel": "o pana ala",
  "report.block": "o len e jan",
  "report.block_explanation": "sina kama lukin ala e toki ona. ona li kama ala ken lukin e toki sina li kama ala ken kute e sina. ona li ken sona e kama ni.",
  "report.categories.other": "ante",
  "report.categories.spam": "ike tan toki mute",
  "report.category.title": "ike seme li lon {type} ni",
  "report.category.title_account": "lipu",
  "report.category.title_status": "toki",
  "report.close": "ale li pona",
  "report.mute": "o kute ala e ona",
  "report.mute_explanation": "sina kama ala lukin e ijo pana ona. ona li awen ken kute e sina li awen ken lukin e sina li sona ala e weka kute sina e weka lukin sina.",
  "report.next": "awen",
  "report.reasons.dislike": "ni li ike tawa mi",
  "report.reasons.legal": "ni li ike tawa lawa",
  "report.reasons.other": "ni li ike tan ante",
  "report.reasons.spam": "ni li ike tan toki mute",
  "report.thanks.title": "sina wile ala lukin e ni anu seme?",
  "report.unfollow": "o kute ala e {name}",
  "report_notification.categories.legal": "ike tawa nasin lawa",
  "report_notification.categories.other": "ante",
  "search.no_recent_searches": "alasa ala li lon tenpo poka",
  "search.placeholder": "o alasa",
  "search.quick_action.go_to_account": "o tawa lipu jan {x}",
  "search_popout.language_code": "nimi toki kepeken nasin ISO",
  "search_popout.recent": "alasa pi tenpo poka",
  "search_popout.specific_date": "tenpo suno wan",
  "search_popout.user": "jan",
  "search_results.accounts": "lipu jan",
  "search_results.all": "ale",
  "search_results.hashtags": "kulupu pi toki suli",
  "search_results.see_all": "ale",
  "search_results.statuses": "toki",
  "server_banner.administered_by": "jan lawa:",
  "status.block": "o len e @{name}",
  "status.cancel_reblog_private": "o pana ala",
  "status.delete": "o weka",
  "status.edit": "o ante",
  "status.favourite": "o sitelen pona",
  "status.history.created": "{name} li pali e ni lon {date}",
  "status.history.edited": "{name} li ante lon {date}",
  "status.load_more": "o kama e ijo ante",
  "status.media.open": "o open",
  "status.media.show": "o lukin",
  "status.media_hidden": "sitelen li len",
  "status.more": "kin",
  "status.mute": "o len e @{name}",
  "status.mute_conversation": "o kute ala e ijo pi toki ni",
  "status.pin": "o sewi lon lipu sina",
  "status.reblog": "o pana sin",
  "status.reblogged_by": "jan {name} li wawa",
  "status.reblogs.empty": "jan ala li pana sin e toki ni. jan li pana sin la, nimi ona li sitelen lon ni.",
  "status.share": "o pana tawa ante",
  "status.show_less_all": "o lili e ale",
  "status.show_more_all": "o suli e ale",
  "status.show_original": "o lukin e mama",
  "status.translate": "o ante pi nasin toki",
  "status.translated_from_with": "toki li ante tan {lang} kepeken {provider}",
  "status.uncached_media_warning": "lukin lili li weka",
  "status.unmute_conversation": "o ken kute e ijo pi toki ni",
  "status.unpin": "o sewi ala lon lipu sina",
  "subscribed_languages.save": "o awen e ante",
  "tabs_bar.home": "lipu open",
  "trends.trending_now": "jan mute li toki",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}AAA",
  "units.short.thousand": "{count}K",
  "upload_button.label": "o pana e sitelen anu kalama",
  "upload_error.limit": "ilo li ken ala e suli pi ijo ni.",
  "upload_form.drag_and_drop.on_drag_cancel": "sina wile ala pana e sitelen. mi weka e sitelen.",
  "upload_form.edit": "o ante",
  "upload_progress.label": "ilo li kama jo e ijo sina...",
  "upload_progress.processing": "ilo li pali…",
  "username.taken": "jan ante li kepeken e nimi ni. sina o kepeken e nimi sin",
  "video.close": "o weka e ni",
  "video.download": "o jo e ni",
  "video.exit_fullscreen": "o weka tan sitelen suli",
  "video.expand": "o suli e ni",
  "video.hide": "o len e sitelen",
  "video.pause": "o lape e ni"
}
